import { useTracking } from 'react-tracking';
import { useState } from 'react';
import loadable from '@loadable/component';
import ChevronRightIcon from '@simplywallst/ui-core/icons/ChevronRightSmallSolid';
import { useTranslation } from '@/hooks/useTranslation';
import { Bones } from './Bones';
import { useMetricData } from '../hooks/useMetricData';

const AnalystsModal = loadable(
  () => import('@/pages/CompanyReport/components/AnalystsModal')
);

type Props = {
  lastAnalysisUpdateFormatted: string;
  analystCount: number;
  handleToggleCompanyAnalystsModal: () => void;
};

const Sources = ({
  lastAnalysisUpdateFormatted,
  analystCount,
  handleToggleCompanyAnalystsModal,
}: Props) => {
  const t = useTranslation();

  return (
    <button
      key="value"
      type="button"
      className="text-softer hover:text-soft focus-visible:ring sm:text-left"
      onClick={handleToggleCompanyAnalystsModal}
    >
      <span className="whitespace-nowrap">
        {t('page.companyReport.header.metadata.data')} from{' '}
      </span>
      {t('page.companyReport.header.metadata.companyFinancials')}
      <span className="whitespace-nowrap">
        {analystCount > 0 &&
          typeof lastAnalysisUpdateFormatted !== 'undefined' &&
          // TODO: Make '&' translatable?
          ` & ${t('page.companyReport.header.metadata.analyst', {
            count: analystCount,
          })}`}
        <ChevronRightIcon
          className="ml-px h-auto w-3.5 fill-current align-middle"
          aria-hidden="true"
        />
      </span>
    </button>
  );
};

export const DataSources = () => {
  const data = useMetricData();

  const [showModal, setShowModal] = useState(false);
  const { trackEvent } = useTracking();

  const handleToggleCompanyAnalystsModal = () => {
    if (data.status === 'loading') return;
    trackEvent({
      action: 'click',
      subject: 'analystCount',
      analystCount: data.analystCount,
    });
    setShowModal(true);
  };

  // data.status = 'loading';

  return (
    <>
      <div className="text-softer">
        {data.status === 'loading' ? (
          <Bones className="w-[30ch] max-w-full" />
        ) : (
          <Sources
            analystCount={data.analystCount}
            lastAnalysisUpdateFormatted={data.lastAnalysisUpdateFormatted}
            handleToggleCompanyAnalystsModal={handleToggleCompanyAnalystsModal}
          />
        )}
      </div>
      {showModal && data.status !== 'loading' && (
        <AnalystsModal
          companyId={data.companyId}
          closeModal={() => setShowModal(false)}
        />
      )}
    </>
  );
};
